module.exports = __webpack_public_path__ + "img/mark.1643c04f.png";